'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.values = exports.RP = exports.PS = exports.VS = exports.IR = exports.OSTATNI = exports.P = exports.ID = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _params;

exports.getCaption = getCaption;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// @Conf
// #hasDoc=true

// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2025-06-17T17:58:45Z                      #

// ##############################################################

/**
 * Typ dokladu.
 */

/**
 * Občanský průkaz.
 */
var ID = exports.ID = 'ID';

/**
 * Cestovní doklad.
 */
var P = exports.P = 'P';

/**
 * Ostatní.
 */
var OSTATNI = exports.OSTATNI = 'OSTATNI';

/**
 * Povolení k pobytu.
 */
var IR = exports.IR = 'IR';

/**
 * Vízový štítek.
 */
var VS = exports.VS = 'VS';

/**
 * Pobytový štítek.
 */
var PS = exports.PS = 'PS';

/**
 * Řidičský průkaz.
 */
var RP = exports.RP = 'RP';

/**
 * Seznam všech hodnot.
 */
var values = exports.values = [ID, P, OSTATNI, IR, VS, PS, RP];

/**
 * Mapa enumu na objekt s podrobnostmi o enumu.
 */
var params = (_params = {}, (0, _defineProperty3.default)(_params, ID, { caption: 'Občanský průkaz.' }), (0, _defineProperty3.default)(_params, P, { caption: 'Cestovní doklad.' }), (0, _defineProperty3.default)(_params, OSTATNI, { caption: 'Ostatní.' }), (0, _defineProperty3.default)(_params, IR, { caption: 'Povolení k pobytu.' }), (0, _defineProperty3.default)(_params, VS, { caption: 'Vízový štítek.' }), (0, _defineProperty3.default)(_params, PS, { caption: 'Pobytový štítek.' }), (0, _defineProperty3.default)(_params, RP, { caption: 'Řidičský průkaz.' }), _params);

/**
 * Načtení popisku enumu.
 * @return popisek enumu
 */
function getCaption(value) {
  return params[value].caption;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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